import StatisticLayout from "../components/StatisticLayout"
import { createTheme, ThemeProvider } from '@mui/material/styles';
import * as React from 'react';
import Container from '@mui/material/Container';

import BackgroundHome from "../components/headers/HomeHeader";
import HomeBody from "../components/HomeBody";
import HomeGallery from "../components/HomeGallery";
import "../components/headers/Headers.css";

const defaultTheme = createTheme();

export default function Home() {
  return (
    <>
    <div className="Headers">
        <BackgroundHome />
    </div>
    <ThemeProvider theme={defaultTheme}>
      <HomeBody/ >
      <br></br>
      <Container maxWidth="md" sx={{ display: "flex", justifyContent: "center" }}>
        <HomeGallery />
        <br></br>
      </Container>
      {/* <Container justifyContent="center" maxWidth='sm'>
        <Paper elevation={0} style={{maxWidth:250}}>
          <StatisticLayout />
        </Paper>
      </Container> */}
    </ThemeProvider>
    </>
  );
}
